// extracted by mini-css-extract-plugin
module.exports = {"page":"pS","account":"qS","pdp":"rS","cart":"sS","brand":"tS","cartModal":"uS","checkout":"vS"};